<template>
  <div class="content">
    <el-row :gutter="20">
      <!--代理商数据-->
      <el-col :span="5" :xs="24">
        <div class="head-container">
          <el-input
            v-model="agentName"
            placeholder="请输入公司名称"
            clearable
            prefix-icon="el-icon-search"
            style="margin-bottom: 20px"
            @change="changeAgentName"
          />
        </div>
        <div class="head-container">
          <el-tree
            class="agent-tree"
            :data="agentList"
            :props="agentProps"
            node-key="userId"
            :expand-on-click-node="true"
            :filter-node-method="agentFilterNode"
             ref="tree"
            :default-expand-all="expandNode"
            :highlight-current="true"
            @node-click="handleNodeClick"
          />
        </div>
      </el-col>
      <!--数据-->
      <el-col :span="19" :xs="24">
          <el-form :model="queryParams" ref="queryParams" :inline="true">
            <el-form-item prop="rule">
              <el-select v-model="queryParams.rule" filterable  clearable placeholder="是否设置规则">
                <el-option v-for="item in status" :key="item.key" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="level">
              <el-select v-model="queryParams.level" filterable  clearable placeholder="代理商层级">
                <el-option v-for="item in levels" :key="item.key" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
              <el-button type="primary" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
              <el-button type="primary" icon="el-icon-plus" @click="handleCreate" >新增套餐规则</el-button>
            </el-form-item>
          </el-form>
          <div class="table">
            <el-table :data="tableData" border >
              <el-table-column prop="company" label="公司名称" align="center" min-width="200" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  [{{scope.row.username}}]{{scope.row.company}}
                </template>
              </el-table-column>
              <el-table-column prop="level" label="公司层级" align="center">
                <template slot-scope="scope">
                  {{scope.row.level}}级
                </template>
              </el-table-column>
              <el-table-column prop="rate" label="设置规则" align="center" >
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.rule=='1'">是</el-tag>
                  <el-tag type="danger" v-else>否</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="productName" label="套餐名称" align="center" min-width="120">
                <template slot-scope="scope" v-if="!!scope.row.productName">
                  [{{scope.row.productId}}]{{scope.row.productName}}
                </template>
              </el-table-column>
              <el-table-column prop="times" label="最大充值次数" align="center" min-width="120"></el-table-column>
              <el-table-column prop="startTime" label="套餐生效时间" align="center" min-width="120"></el-table-column>
              <el-table-column prop="endTime" label="套餐结束时间" align="center" min-width="120"></el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="200" align="center"></el-table-column>
              <el-table-column label="操作" align="center" width="180" fixed="right">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" plain icon="el-icon-edit" @click="handleEdit(scope.row)" >编辑</el-button>
                  <el-button size="mini" type="danger" plain icon="el-icon-delete" @click="deleteRate(scope.row)" >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="page">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-size="pageSize"
              :page-sizes="[10, 20, 30, 40]"
              @size-change="handleSizeChange"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
          </div>
      </el-col>
    </el-row>
    <!--批量设置  -->
    <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="130px" :inline="false">
          <el-form-item label="代理商">
              <el-input  type="text" v-model="form.agentName" disabled style="width: 100%;"></el-input>
          </el-form-item>
          <el-form-item  label="限制套餐" prop="productId">
            <el-select v-model="form.productId"  placeholder="请选择套餐" filterable  style="width: 100%;">
            <el-option
                  v-for="dict in products"
                  :key="dict.productId"
                  :label="'['+dict.productId+']'+dict.productName"
                  :value="dict.productId"
                ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="最大充值次数" prop="times">
            <span slot="label">
              <el-tooltip content="最大充值次数：-1表示不限制，0表示不展示次套餐 大于0表示充值次数达到就不再显示此套餐" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              最大充值次数
            </span>
            <el-input placeholder="最大充值次数" v-model.number="form.times" type="text" style="width: 100%;"></el-input>
          </el-form-item>
          <el-form-item   prop="startTime" >
            <span slot="label">
              <el-tooltip content="达到此设置时间，H5页面充值套餐才会展示" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              套餐开始时间
            </span>
            <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="套餐开始时间" v-model="form.startTime" style="width: 100%;"></el-date-picker>
          </el-form-item>
          <el-form-item   prop="endTime" >
            <span slot="label">
              <el-tooltip content="达到此设置时间，H5页面充值套餐不会展示" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              套餐结束时间
            </span>
            <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="套餐结束时间" v-model="form.endTime" style="width: 100%;"></el-date-picker>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!--修改代理商  -->
    <el-dialog :title="editTitle" :visible.sync="editOpen" width="700px" append-to-body :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="130px">
          <el-form-item  label="代理商名称">
            <el-input  v-model="editForm.company" disabled style="width: 100%;"></el-input>
          </el-form-item>
          <el-form-item  label="限制套餐" prop="productId">
            <el-select v-model="editForm.productId"  placeholder="请选择套餐" filterable  style="width: 100%;">
            <el-option
                  v-for="dict in products"
                  :key="dict.productId"
                  :label="'['+dict.productId+']'+dict.productName"
                  :value="dict.productId"
                ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="最大充值次数" prop="times">
            <span slot="label">
              <el-tooltip content="最大充值次数：-1表示不限制，0表示不展示次套餐 大于0表示充值次数达到就不再显示此套餐" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              最大充值次数
            </span>
            <el-input placeholder="最大充值次数" v-model.number="editForm.times" type="text" style="width: 100%;"></el-input>
          </el-form-item>
          <el-form-item   prop="startTime" >
            <span slot="label">
              <el-tooltip content="达到此设置时间，H5页面充值套餐才会展示" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              套餐开始时间
            </span>
            <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="套餐开始时间" v-model="editForm.startTime" style="width: 100%;"></el-date-picker>
          </el-form-item>
          <el-form-item   prop="endTime" >
            <span slot="label">
              <el-tooltip content="达到此设置时间，H5页面充值套餐不会展示" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              套餐结束时间
            </span>
            <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="套餐结束时间" v-model="editForm.endTime" style="width: 100%;"></el-date-picker>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editSubmit">确 定</el-button>
        <el-button @click="cancelEdit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { agentTreeList,productLimitPage,productsByUserId ,saveProductLimit,updateProductLimit,productLimitRemove} from "@/api/api.js";
export default {
  name: "productLimit",
  data() {
    return {
      // 查询条件
      agentList:[],
      expandNode:false,
      userId:'',
      queryParams: {
        userId:undefined
      },
      status:[
        {key:"1",value:"是"},
        {key:"0",value:"否"}
      ],
      levels:[
        {key:"1",value:"一级"},
        {key:"2",value:"二级"},
        {key:"3",value:"三级"},
        {key:"4",value:"四级"},
        {key:"5",value:"五级"},
        {key:"6",value:"六级"},
      ],
      // 分页器
      page: 1,
      pageSize: 10,
      total: 10,
      // 列表数据
      tableData: [],
      title:"",
      // 是否显示弹出层
      open: false,
      // 表单参数
      form: {
        agentName:undefined,
        userId:undefined,
        times:"-1",
        startTime:"",
        endTime:"",
        productId:undefined,
      },
      products:[],
      agentName:'',
      agentProps:{
        children: "children",
        label: "label"
      },
      rules: {
          times:[
            { required: true, message: '最大充值次数不能为空'}
          ],
          productId:[
             { required: true, message: '限制套餐不能为空'},
          ],
      },
      editTitle:"修改套餐限制规则",
      editOpen:false,
      editForm:{
        userId:undefined,
        company:undefined,
        productId:undefined,
        times:"-1",
        startTime:"",
        endTime:"",
      },
      editRules: {
        times:[
            { required: true, message: '最大充值次数不能为空'}
          ],
          productId:[
             { required: true, message: '限制套餐不能为空'},
          ],
      },
    };
  },
  watch: {
      agentName(val) {
        this.$refs.tree.filter(val);
      }
    },
  computed: {},
  methods: {
    // 清空公司名称
    changeAgentName(){
      if(!this.agentName){
        this.queryParams.userId = "";
      }
    },
    // 搜索
    search() {
      this.page = 1,
      this.tabeInit();
    },
    //代理商层级
    agentTree(){
      agentTreeList().then(res => {
        if (res.data.code == 200) {
          this.agentList = res.data.data;
        }
      });
    },
    // 获取列表
    tabeInit() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      productLimitPage(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        }else{
          this.$message.error(res.data.message);
        }
      });
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.tabeInit();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.tabeInit();
    },
    // 添加
    handleCreate() {
      if(!this.queryParams.userId){
          this.$message({
            message: '请在左侧栏选择你要操作的代理商！',
            type: 'warning'
          });
          return false;
      }
      this.productsByUserMethod();
      this.title = "代理商配置规则";
      this.open = true;

    },
    productsByUserMethod(){
      productsByUserId({userId:this.userId}).then(res=>{
          if(res.data.code == 200){
              this.products = res.data.data
          }
      })
    },
    // 编辑
    handleEdit(row) {
      this.userId = row.userId;
      this.productsByUserMethod();
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editForm.company = '[' + row.username + ']' + row.company;
      this.editOpen = true;
    },
    //移除
    deleteRate(row){
      this.$confirm('是否确认将【'+row.company+'】的限制规则移除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            productLimitRemove({id:row.id}).then(res=>{
                if(res.data.code == 200){
                    this.$message.success("删除成功");
                    this.search();
                }
            });
        })
    },
    // 重置
    resetQuery() {
      this.agentName = '';
      this.treeExpand(false);
      this.queryParams.userId = undefined;
      this.resetForm("queryParams");
      this.tabeInit();
    },
    // 搜索
    handleSearch() {
      this.page = 1;
      this.tabeInit();
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.search();
    },
    treeExpand(flag){
        let treeList = this.agentList;
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.tree.store.nodesMap[treeList[i].userId].expanded = flag;
        }
    },
    // 节点单击事件
    handleNodeClick(data) {
      this.queryParams.userId = data.userId;
      this.form.userId = data.userId;
      this.userId = data.userId;
      this.form.agentName = '[' + data.username + ']' + data.label;
      this.tabeInit();
    },
    agentFilterNode(value, data, node){
      if (!value) return true
      let if_one = data.label.indexOf(value) !== -1
      let if_two = node.parent && node.parent.data && node.parent.data.label && (node.parent.data.label.indexOf(value) !== -1)
      let if_three = node.parent && node.parent.parent && node.parent.parent.data && node.parent.parent.data.label && (node.parent.parent.data.label.indexOf(value) !== -1)
      let result_one = false
      let result_two = false
      let result_three = false
      if(node.level === 1) {
        result_one = if_one
      }else if(node.level === 2) {
        result_two = if_one || if_two
      }else if(node.level === 3) {
        result_three = if_one || if_two || if_three
      }
      return result_one || result_two || result_three
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          saveProductLimit(this.form).then(res => {
            if(res.data.code == 200){
                this.$message.success("代理商套餐限制规则设置成功");
                this.open = false;
                this.resetForm("form");
                this.search();
            }else{
                this.$message.error(res.data.message);
            }
            
          });
        }
      });
    },
    editSubmit(){
        this.$refs["editForm"].validate(valid => {
          if (valid) {
            if(!this.editForm.id){
              saveProductLimit(this.editForm).then(res => {
                if(res.data.code == 200){
                  this.$message.success("代理商套餐限制规则设置成功");
                  this.editOpen = false;
                  this.resetForm("editForm");
                  this.search();
                }else{
                  this.$message.error(res.data.message);
                }
                
              });
            }else{
              updateProductLimit(this.editForm).then(res => {
                if(res.data.code == 200){
                    this.$message.success("代理商套餐限制规修改成功");
                    this.editOpen = false;
                    this.resetForm("editForm");
                    this.search();
                }else{
                  this.$message.error(res.data.message);
                }
                
            });
            }
            
          }
        });
    },
    cancelEdit(){
      this.editOpen = false;
      this.search();
    }
  },
  mounted() {
  },
  created() {
    this.agentTree();
    this.tabeInit();
  }
};
</script>
<style scoped lang="less">

.down-tree{
    margin-bottom: 10px;
    height: 300px;
    display: block;
    overflow-y: scroll;

}
@media (min-width: 1156px) {
  .agent-tree{
    height: 700px;
    display: block;
    overflow-y: scroll;
    overflow-x: hidden;

  }
}
@media screen and (min-width: 768px) and (max-width: 1156px){
	.agent-tree{
    height: 500px;
    display: block;
    overflow-y: scroll;
    overflow-x: hidden;

  }
}
</style>